import styled, { css } from 'styled-components';
import { duration } from '@stylesheets/motion';

export const WorkspaceSlot = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin-top: 37px;
`;

export const WorkspaceLabel = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 6px;
  border: 0;
  background: transparent;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;

  ${({ theme: { colors, borderRadius } }) => css`
    border-radius: ${borderRadius.full};
    color: ${colors.onSurfaceVariant};
    transition: color ${duration.fast} ease;

    &:hover {
      color: ${colors.onSurface};
    }

    &:focus-visible {
      outline: 2px solid ${colors.primary};
      outline-offset: 2px;
    }
  `}
`;
